var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisConnectedBluetooth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4974 18.8334L12.9974 15.3334L9.9974 18.3334H9.16406V12.0001L5.33073 15.8334L4.16406 14.6667L8.2474 10.5834L1.16406 3.50008L2.33073 2.33341L17.6641 17.6667L16.4974 18.8334ZM10.8307 15.1251L11.7891 14.1667L10.8307 13.2084V15.1251ZM11.7474 9.41675L10.5807 8.25008L12.4141 6.41675L10.8307 4.87508V8.50008L9.16406 6.83342V1.66675H9.9974L14.7474 6.41675L11.7474 9.41675Z",
    fill: "#FF9F0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisConnectedBluetooth);
export default __webpack_public_path__ + "static/media/disConnectedBluetooth.46da0160072fc3f8c6dee083a45faa45.svg";
export { ForwardRef as ReactComponent };